import { render, staticRenderFns } from "./EntityTable.vue?vue&type=template&id=4b386be7&"
import script from "./EntityTable.vue?vue&type=script&lang=js&"
export * from "./EntityTable.vue?vue&type=script&lang=js&"
import style0 from "./EntityTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports